<template>
  <div>
    <div class="container mt-4">
      <TopNav :title="$t('GENERAL.LABEL.REPORTS')" :showOpenMainNav="true">
      </TopNav>
      <div class="row mb-4">
        <div
          class="col-lg-6 p-3"
          v-for="(reportPage, index) in reportPageList"
          :key="index"
        >
          <router-link :to="reportPage.to" class="undecorated-router-link">
            <SettingsCard
              :smallTitle="reportPage.smallTitle"
              :mainTitle="reportPage.mainTitle"
              :description="reportPage.description"
              :img="reportPage.img"
              :buttonText="reportPage.buttonText"
              buttonIcon="fal fa-search"
            ></SettingsCard>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TopNav from '@/web/components/navigation/TopNav.vue';
import SettingsCard from '@/web/components/settings/SettingsCard.vue';
import { getConfig } from '@/web/utils/configuration';

export default {
  name: 'Reports',
  components: {
    TopNav,
    SettingsCard,
  },
  computed: {
    reportPageList() {
      return [
        {
          to: { name: 'report-group-list', params: { group: 'users' } },
          smallTitle: this.$t('REPORTS.LABEL.WHAT_ARE_THEY_UP_TO'),
          mainTitle: this.$t('REPORTS.LABEL.STUDENTS_AND_ACTIVITY'),
          description: this.$t(
            'REPORTS.TEXT.STUDENTS_AND_ACTIVITY_DESCRIPTION'
          ),
          img: this.config['report-students-and-activity-img'],
          buttonText: this.$t('REPORTS.LABEL.STUDENTS_AND_ACTIVITY_CTA'),
        },
        /*
        {
          to: { name: 'report-group-list', params: { group: 'products' } },
          smallTitle: this.$t('REPORTS.LABEL.HOW_CAN_I_IMPROVE'),
          mainTitle: this.$t('REPORTS.LABEL.PRODUCTS'),
          description: this.$t('REPORTS.TEXT.PRODUCTS_DESCRIPTION'),
          img: '/assets/images/settings/custom_domain.svg',
          buttonText: this.$t('REPORTS.LABEL.PRODUCTS_CTA'),
        },
        */
        {
          to: { name: 'report-group-list', params: { group: 'sales' } },
          smallTitle: this.$t('REPORTS.LABEL.HOW_MUCH_DID_I_EARN'),
          mainTitle: this.$t('REPORTS.LABEL.SALES'),
          description: this.$t('REPORTS.TEXT.SALES_DESCRIPTION'),
          img: this.config['report-sales-img'],
          buttonText: this.$t('REPORTS.LABEL.SALES_CTA'),
        },
        {
          to: { name: 'report-group-list', params: { group: 'media' } },
          smallTitle: this.$t('REPORTS.LABEL.WHAT_ARE_THEY_WATCHING'),
          mainTitle: this.$t('REPORTS.LABEL.MEDIA'),
          description: this.$t('REPORTS.TEXT.MEDIA_DESCRIPTION'),
          img: '/assets/images/sitting_on_beanbag_w_table.svg',
          buttonText: this.$t('REPORTS.LABEL.MEDIA_CTA'),
        },
      ];
    },
    config() {
      return getConfig();
    },
  },
};
</script>
<style lang="scss" scoped></style>
